// extracted by mini-css-extract-plugin
module.exports = {"radishCost":"RadishCostText_radishCost__OcJs0","originalCost":"RadishCostText_originalCost__cmKTU"};